import { AiToolImpl } from "@me8eon/aiclient";
import { WidgetMeta } from "@me8eon/ai.tools.utils/src/widget";

type ToolArgs = Record<string, never>;
type ToolImpl = AiToolImpl<ToolArgs>;
type Tool = () => ToolImpl;

export const DisplayCreateIncidentActionToolImpl: Tool = () => {
    return {
        type: "service_api",
        toolDefn: {
            type: "function",
            name: "display_create_incident_action",
            description:
                "This tool displays a create incident widget for ServiceNow. Here user can create/raise a new incident.",
            parameters: {
                type: "object",
                properties: {},
                required: [],
                additionalProperties: false,
            }
        },
        execute: async (_options, _args) => {
            const widgetMeta: WidgetMeta = {
                name: "create_incident_widget",
                title: "Create Incident in ServiceNow",
                description: "Displays a widget to create an incident in ServiceNow",
                type: "widget",
                componentName: "CreateIncidentActionWidget",
                props: {}
            };

            return {
                _meta: {
                    widget: widgetMeta,
                    skipAiSummary: true
                },
                value: "Displaying Create Incident Widget"
            };
        }
    };
};